import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';
import './cookie-consent.css';

class CookieConsent extends Component {
  constructor(props) {
    const necessaryCookiesAccepted = localStorage.getItem('NecessaryCookies') === '1';
    const recommendedCookiesAccepted = localStorage.getItem('RecommendedCookies') === '1';
    super(props);
    this.state = {
      cookieConsentAccepted: necessaryCookiesAccepted || recommendedCookiesAccepted
    };
  }

  acceptRecommendedCookies = () => {
    localStorage.setItem('RecommendedCookies', '1');
    this.setState(() => ({
      cookieConsentAccepted: true,
    }));
    window.location.reload(false);
  }

  acceptNecessaryCookies = () => {
    localStorage.setItem('NecessaryCookies', '1');
    this.setState(() => ({
      cookieConsentAccepted: true,
    }));
  }
  render() {
    return (
      <Modal
        animation={false}
        dialogClassName='cookie-consent'
        container={this}
        aria-labelledby="contained-modal-title"
        show={!this.state.cookieConsentAccepted && !document.URL.includes('privacy-policy')}
      >
        <Modal.Body>
          <div className={'cookie-consent-content'}>
            <div className={'content cookie-header'}>
              <h3>We care about your privacy</h3>
              <p>
                We use cookies to make our website
                available to you and to improve your user experience.
                You can choose what cookies you allow us to use.
                For more information, please see our <a target={'_blank'} href={'/content-pages/privacy-policy#cookie-policy'}>Cookie Policy</a>
              </p>
            </div>
            <div className={'content green'}>
              <b>STRICTLY NECESSARY COOKIES</b>
              <p>
                These cookies are essential to deliver our service and cannot be disabled
                Access Token This is required for login functionality and delivering appropriate content to the user.
              </p>
            </div>
            <div className={'content grey'}>
              <b>PERFORMANCE COOKIES</b>
              <p>
                These cookies allow us to track use of the site and to make improvements&nbsp;
                <b>Google analytics</b> These cookies allow us to track the users journey on the site
                (page visits, length of sessions etc) and make improvements accordingly.
              </p>
            </div>
            <div className={'user-frontend'}>
              <Button
                type="button"
                onClick={this.acceptRecommendedCookies}
                className='red-btn'
              >Accept recommended<br />cookies
              </Button>
              <Button
                type="button"
                onClick={this.acceptNecessaryCookies}
                className='red-btn'
              >Proceed with necessary<br />cookies only
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
export default CookieConsent;



// WEBPACK FOOTER //
// ./src/components/cookie-consent/cookie-consent.jsx